(() => {
  const root = document.querySelector('[data-fw-pdp]');
  if (!root) return;

  /* Remember this mat so the cart page can wear its palette. */
  const mat = document.documentElement.getAttribute('data-mat');
  try {
    if (mat) localStorage.setItem('fw-mat', mat);
  } catch (e) {
    /* private mode — fine */
  }

  /* ---- variant resolution across option groups ---- */
  const idInput = root.querySelector('[data-fw-variant-id]');
  const priceEls = root.querySelectorAll('[data-fw-price]');
  const totalEl = root.querySelector('[data-fw-total]');
  const atc = root.querySelector('[data-fw-atc]');
  const atcLabel = atc ? atc.querySelector('span') : null;
  const optionSets = [...root.querySelectorAll('[data-fw-option]')];

  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-fw-variant-data]').textContent);
  } catch (e) {
    variants = [];
  }

  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  const selectedValues = () =>
    optionSets.map((set) => {
      const checked = set.querySelector('input:checked');
      return checked ? checked.value : null;
    });

  const findVariant = (values) =>
    variants.find((v) =>
      values.every((val, i) => val === null || v[`option${i + 1}`] === val)
    );

  const sync = () => {
    const values = selectedValues();
    const variant = findVariant(values);
    if (variant) {
      idInput.value = variant.id;
      priceEls.forEach((el) => (el.textContent = money(variant.price)));
      if (totalEl) totalEl.textContent = money(variant.price);
      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel && window.variantStrings) {
          atcLabel.textContent = variant.available
            ? window.variantStrings.addToCart
            : window.variantStrings.soldOut;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

  };

  optionSets.forEach((set) =>
    set.addEventListener('change', sync)
  );
  sync();

  const form = root.querySelector('.fw-buy-form');
  if (form) {
    form.addEventListener('submit', () => {
      /* Empty optional fields never post: no blank line-item properties reach
         the production partner. product-form serializes synchronously after
         this handler, then we restore the inputs. */
      const blanks = [...form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')]
        .filter((i) => !i.disabled && i.type !== 'checkbox' && i.value.trim() === '');
      blanks.forEach((i) => (i.disabled = true));
      setTimeout(() => blanks.forEach((i) => (i.disabled = false)), 150);
    });
  }

  /* ---- mobile sticky buy bar ---- */
  /* Appears after roughly one screen of scrolling, so a cold visitor meets a
     price and a buy button without hunting for them. It still steps aside
     while the real buy block is on screen, so there are never two Add to Cart
     buttons at once. */
  const bar = root.querySelector('[data-fw-stickybar]');
  const buyCol = root.querySelector('[data-fw-buy]');
  if (bar && buyCol) {
    let buyOnScreen = false;

    /* Two comparisons — cheap enough to run inline on scroll, and writing
       .hidden only on a change keeps it off the layout path. */
    const sync = () => {
      const next = buyOnScreen || window.scrollY < window.innerHeight * 0.9;
      if (bar.hidden !== next) bar.hidden = next;
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            buyOnScreen = entry.isIntersecting;
          });
          sync();
        },
        { rootMargin: '0px 0px -20% 0px' }
      ).observe(buyCol);
    }

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }
})();
